/** @jsx jsx */
import { jsx } from '@emotion/core';
import { useState } from 'react';
import PropTypes from 'prop-types';

import {
    Card,
    Icon,
    Property,
    SpaceBookingsTable,
    BookingStatus
} from 'school-space-client/components';

import css from './css';

const PastBookingCard = ({ booking }) => {
    const [expanded, setExpanded] = useState(false);

    const { dateString, school, site, spaces, state } = booking;
    const location = site ? `${school.name} (${site.name})` : school.name;

    const bookingIsCancelled = state.id === 'cancelled';

    return (
        <Card styles={css.wrapper}>
            <div css={css.header}>
                <div css={css.propertyRow}>
                    <Property title="Date" styles={css.property}>
                        {dateString}
                    </Property>
                    <Property title="Location" styles={css.property}>
                        {location}
                    </Property>
                </div>
                <div css={css.meta}>
                    {bookingIsCancelled && <BookingStatus state={state.id} />}
                    <Icon
                        styles={css.arrow(expanded)}
                        name="arrow"
                        ariaExpanded={expanded}
                        ariaLabel="toggle booking card"
                        onClick={() => setExpanded(!expanded)}
                    />
                </div>
            </div>
            <div css={css.content({ visible: expanded })} aria-hidden={!expanded}>
                <div css={css.spaces}>
                    <SpaceBookingsTable spaceBookings={spaces} focusable={expanded} />
                </div>
            </div>
        </Card>
    );
};

PastBookingCard.propTypes = {
    booking: PropTypes.objectOf(PropTypes.any).isRequired
};

export default PastBookingCard;
